// slider arrow icon
const SliderArrow = () => {
  return (
    <svg width="55" height="38" viewBox="0 0 55 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM53.7678 20.7678C54.7441 19.7915 54.7441 18.2085 53.7678 17.2322L37.8579 1.32233C36.8816 0.34602 35.2986 0.34602 34.3223 1.32233C33.346 2.29864 33.346 3.88155 34.3223 4.85786L48.4645 19L34.3223 33.1421C33.346 34.1184 33.346 35.7014 34.3223 36.6777C35.2986 37.654 36.8816 37.654 37.8579 36.6777L53.7678 20.7678ZM3 21.5H52V16.5H3V21.5Z" fill="white"/>
    </svg>
  );
};

export default SliderArrow;